<template>
  <table class="my-table-content">
    <thead>
      <tr>
        <th
          :class="{ ...headStyle, 'my-table-Header': true }"
          v-for="(item, index) in headers"
          :key="'coll-' + index"
        >
          {{ item.text }}
        </th>
      </tr>
    </thead>
    <tbody :style="TbodyStyle">
      <tr v-if="!items.length">
        <td :colspan="headers.length">
          <p class="text-center text-secondary">No data</p>
        </td>
      </tr>

      <tr v-for="(item, row) in items" :key="'row-' + row">
        <td
          :class="{ ...bodyStyle }"
          v-for="(item2, coll) in headers.length"
          :key="'cell-' + row + ',' + coll"
        >
          <slot :name="'coll.' + headers[coll].text" :row="item">
            {{ item[headers[coll].value] }}
          </slot>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <slot name="tableFoot"></slot>
        <!-- <td></td>
        <td>$180</td>
        <td>$180</td> -->
      </tr>
    </tfoot>
  </table>
</template>
<script>
export default {
  props: {
    headers: { type: Array, required: true },
    items: { type: Array, required: true },
    myStyle: { type: Object, default: () => ({}) },
    // loading: { type: Boolean, default: false }
  },
  computed: {
    TbodyStyle() {
      const { tBodyStyle } = this.myStyle;
      return tBodyStyle ? tBodyStyle : {};
    },
    headStyle() {
      const { headStyle } = this.myStyle;
      return headStyle ? headStyle : {};
    },
    bodyStyle() {
      // my-table-border
      const { bodyStyle } = this.myStyle;
      return bodyStyle ? bodyStyle : {};
      //   "my-table-border": false
    },
  },
};
</script>
<style scoped src="@/assets/style/TableStyle.module.css"></style>
